<span>{{ params.value | customDate: 'mediumDate' : preferredLanguage }} </span>
@if (
  isExpiringSoon() &&
  (params.data.status === LINK_STATUS.REDEEMED ||
    params.data.status.toLowerCase() === TRIAL_STATUS.ACTIVE.toLowerCase())
) {
  <span class="expire-soon" [raUiBadge]="'value'" [badgeConfig]="badgeConfig"> Expiring Soon </span>
}
